import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'


export const mainApi = createApi({
  reducerPath: 'mainApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://tpomobi.shop' }),
  endpoints: (builder) => ({
    findAllWords: builder.query({
      query: () => ({
        url: '/getProductsEnabled',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: [ { type: 'Product', id: 'LIST' } ],
      keepUnusedDataFor: 36,
      pollInterval: 36000,
    }),
    findAllWordsByTradeName: builder.query({
      query: (tradeName) => ({
        url: `/useFindAllWordsQuery?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: [ { type: 'Product', id: 'LIST' } ],
      keepUnusedDataFor: 36,
      pollInterval: 36000,
    }),
    getProductById: builder.query({
      query: (id) => ({
        url: `/getProductsAdmin/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getAllOrders: builder.query({
      query: () => ({
        url: '/getOrdersAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getOrdersById: builder.query({
      query: (id) => ({
        url: `/getOrdersAdmin/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getAllContacts: builder.query({
      query: () => ({
        url: '/getContactsAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getContactsById: builder.query({
      query: (id) => ({
        url: `/getContactsAdmin/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getCategoryList: builder.query({
      query: () => ({
        url: '/getProductsLanding',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getBrandsList: builder.query({
      query: () => ({
        url: '/getBrandsLanding',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getBusinessTypeList: builder.query({
      query: () => ({
        url: '/getBusinessTypeLanding',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        invalidatesTags: ['ContactBusiness'],
      }),
    }),
    getSpecializationList: builder.query({
      query: () => ({
        url: '/getSpecializationLanding',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getProductsAdminSearch: builder.query({
      query: () => ({
        url: '/getProductsAdminSearch',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getProductsAdminSearchInput: builder.query({
      query: (name) => ({
        url: '/getProductsAdminSearchByName',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          name
        }
      }),
    }),
    getOrderItemsByTradeName: builder.query({
      query: (query) => ({
        url: '/getOrdersUniqueAdminByTradeName',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName: query || '',
        },
      }),
    }),
    getFacturasByClient: builder.query({
      query: (query) => ({
        url: `/getFacturasByClientAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName: query.tradeName,
        },
      }),
      transformResponse: (response) => response.reverse(),
      providesTags: ['History'],
    }),
    getOrdersByTradeName: builder.query({
      query: (tradeName) => ({
        url: `/getOrdersAdminByTradeName?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      transformResponse: (response) => response.reverse(),
    }),
    getContactTradeNameByPhone: builder.query({
      query: (search) => ({
        url: `/getContactTradeNameByPhone?search=${search}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getProductsBySkus: builder.query({
      query: (query) => ({
        url: '/getProductsBySku',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          skus: query.skus || '',
        },
      }),
      providesTags: ['Products'],
    }),
    getClientPersonalSales: builder.query({
      query: (tradeName) => ({
        url: `/getClientPersonalSales?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getContactClientByTradeName: builder.query({
      query: (tradeName) => ({
        url: `/getContactClientByTradeName?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getContactAmbassadorByTradeNameAdmin: builder.query({
      query: (tradeName) => ({
        url: `/getContactAmbassadorByTradeNameAdmin?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getBuisnessContactByTradeName: builder.query({
      query: (tradeName) => ({
        url: `/getBuisnessContactByTradeName?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),   
    }),
    getOrdersByIds: builder.query({
      query: (ids) => ({
        url: `/getOrdersByIds`,
        headers: {
          'Content-Type': 'application/json',
        },
        params: { ids }, // Use the array directly as the value for the 'ids' parameter
        method: 'GET',
      }),
      providesTags: ['ShipmentOrders'],
    }),
    getStatsByTradeNames: builder.query({
      query: (tradeNames) => ({
        url: `/getStatsByTradeName?tradeNames=${tradeNames}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getOrdersByWeekAdmin: builder.query({
      query: (tradeNames) => ({
        url: `/getOrdersByWeekAdmin?tradeNames=${tradeNames}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getContactsTradeNamesAdmin: builder.query({
      query: (tradeNames) => ({
        url: `/getContactsTradeNamesAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),

    
    createNewOrder: builder.mutation({
      query: (body) =>  ({
        url: './createOrderAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body
      })
    }),
    createNewOrderBrowser: builder.mutation({
      query: (body) =>  ({
        url: './createOrderAdminBrowser',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body
      })
    }),
    updateContactAdmin: builder.mutation({
      query: (body) =>  ({
        url: './updateContactAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: body
      })
    }),
    updateOrderItemsAdmin: builder.mutation({
      query: (body) =>  ({
        url: './updateOrderItemsAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body
      })
    }),
    updateDescriptionOrder: builder.mutation({
      query: (body) =>  ({
        url: './changeDescriptionOrder',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body
      })
    }),
    updateStatusOrderAdmin: builder.mutation({
      query: (body) =>  ({
        url: './updateStatusOrderAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body
      })
    }),
    updateCurrentCartContact: builder.mutation({
      query: (body) =>  ({
        url: './updateCurrentCartContact',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body
      })
    }),
    updatePaidByTradeNameContactAdmin: builder.mutation({
      query: (body) =>  ({
        url: './updatePaidByTradeNameContactAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body
      })
    }),
    updateFacturaUpdateField: builder.mutation({
      query: (body) => ({
        url: `/updateFacturaUpdateField`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body,
      }),
      providesTags: ['History'],
    }),
    addClientPersonalPhones: builder.mutation({
      query: (body) =>  ({
        url: './addClientPersonalPhones',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body
      })
    }),


    //SALES ROUTES
    createSale: builder.mutation({
      query: (body) => ({
        url: '/sales',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body
      }),
    }),
    getSales: builder.query({
      query: () => ({
        url: '/sales',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    
  }),
})

